import type { ReactNode } from "react";
import { cn } from "@crew/ui/lib/utils";
import { toneText, type Tone } from "@crew/ui/components/typography";

/** Vertical story of who did what, joined by a 1px rail under each avatar. */
export function Timeline({ children, className }: { children: ReactNode; className?: string }) {
  return <ol className={cn("flex flex-col", className)}>{children}</ol>;
}

export function TimelineEntry({
  avatar,
  name,
  nameTone = "foreground",
  time,
  timeTone = "muted",
  last = false,
  children,
}: {
  /** A 22px AgentAvatar or PersonAvatar. */
  avatar: ReactNode;
  name: ReactNode;
  nameTone?: Tone;
  time?: ReactNode;
  timeTone?: Tone;
  /** Last entry has no rail below it. */
  last?: boolean;
  children?: ReactNode;
}) {
  return (
    <li className="flex gap-3.5">
      <div className="flex w-[22px] shrink-0 flex-col items-center">
        {avatar}
        {last ? null : <span aria-hidden className="min-h-2 w-px flex-1 bg-ink/15" />}
      </div>
      <div className={cn("flex min-w-0 flex-1 flex-col gap-0.5", !last && "pb-4")}>
        <div className="flex gap-2 text-meta">
          <span className={cn("font-semibold", toneText[nameTone])}>{name}</span>
          {time ? <span className={toneText[timeTone]}>{time}</span> : null}
        </div>
        {typeof children === "string" ? (
          <p className="text-[14px] leading-[21px] text-copy">{children}</p>
        ) : (
          children
        )}
      </div>
    </li>
  );
}
